import React from "react";
import Oursevices from "../Component/Ourservices";
import Ourprocess from "../Component/Ourprocess";
import Language from "../Component/Language";


const Services = () => {
    return (
     <>
      
      <Oursevices/>
      <Ourprocess/>
      <Language/>
    </>
      
    );
  };
  
  export default Services;
  